import {getStore} from '../config/mUtils'

export default {
	islogin (state) {
		return state.login
	},
	userInfo(state){
		return state.userInfo
	}
}